import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";
import ColorBlock from "./ColorBlock";
import { Color } from "../../../../core/models/entities/LogoOptions";
import { systemColorDisplayName } from "../../../../utils/systemColors";

function ColorBlockWithToolTip({
  color,
  onClick,
  size,
  embroideryMethod,
}: {
  color: Color;
  onClick: (color: Color) => void;
  size?: "sm" | "md";
  // True when the surrounding logo's transfer method is embroidery — backup
  // rows then show their own name instead of "Backup White" (owner decision
  // 31/8). Optional so surfaces without a logo context keep today's behavior.
  embroideryMethod?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <Tooltip
      title={systemColorDisplayName(color, t, { embroideryMethod }) ?? color.name}
      placement={"right"}
    >
      <div onClick={() => onClick(color)}>
        <ColorBlock size={size} color={color} />
      </div>
    </Tooltip>
  );
}

export default ColorBlockWithToolTip;
